export default __webpack_public_path__ + "static/media/evrfy_new_middle_gr-01.fa95bd63.svg";